
.sbb-label {
  font-size: 13px;
  color: var(--sbb-color-granite);
  margin-bottom: 4px;
}
